import { obterOrdensServicoAsync } from "../../services/ordemServicoService";

const atualizarOrdensServico = async ({ commit }) => {
    const ordensServico = await obterOrdensServicoAsync();
    commit('atualizarOrdensServico', ordensServico);
}

const atualizarOrdemServico = ({ commit }, ordemServico) => {
    commit('atualizarOrdemServico', ordemServico);
}

const updateOrdemServico = ({ commit }, ordemServico) => {
    commit('updateOrdemServico', ordemServico);
}

export default {
    atualizarOrdensServico,
    atualizarOrdemServico,
    updateOrdemServico
}